import { isPlatformServer } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownOptions } from 'src/app/modules/shared/components/shared-button/shared-button.model';
import { ProductCard } from 'src/app/modules/shared/components/shared-product/shared-product-class';
import {
  Product,
  ProductSearch,
} from 'src/app/modules/shared/models/products.model';
import { PanelService } from 'src/app/modules/shared/services/api/panel.service';
import { PaginationService } from 'src/app/modules/shared/services/pagination/pagination.service';
import { StoreRegionService } from 'src/app/modules/shared/services/store-region.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit {
  dropdownOptions: DropdownOptions;

  searchedQuery: string;
  searchResult: ProductSearch[];
  detailedSearchResult: ProductCard[] = undefined;
  resultCount: number;
  showDefaultView: boolean;
  detailMode: boolean;
  isServer: boolean;
  nextpage: string;
  selectedSortLabel: string;
  private sortOptions = [
    {
      label: 'Name A-Z',
      value: 'name',
    },
    {
      label: 'Name Z-A',
      value: '-name',
    },
    {
      label: 'Popular',
      value: 'popularity',
    },
    {
      label: 'Recently Added',
      value: 'created_time',
    },
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private panelService: PanelService,
    private regionService: StoreRegionService,
    private router: Router,
    private paginationService: PaginationService,
    @Inject(PLATFORM_ID) platFormId: Object
  ) {
    this.isServer = isPlatformServer(platFormId);
    this.setSortOptions();
  }

  private setSortOptions() {
    const data = this.sortOptions.map((i) => ({
      ...i,
      isActive: this.activatedRoute.snapshot.queryParams?.sort === i.value,
    }));

    this.dropdownOptions = {
      data,
      onSelect: this.sortBy.bind(this),
    };
  }

  ngOnInit(): void {
    this.listenToSearchParam();
  }

  sortBy(value: string) {
    const query = this.activatedRoute.snapshot.params?.keyword;
    if (!query) return;

    this.performDetailSearch(query, value);
  }

  private getPage() {
    if (this.nextpage != null) {
      this.paginationService.fetchNextData(this.nextpage).subscribe((list) => {
        this.nextpage = list.next;
        this.detailedSearchResult = [
          ...this.detailedSearchResult,
          ...this.getSearchList(list.results),
        ];
      });
      this.nextpage = null;
    }
  }

  goToQuery(query: string) {
    this.router.navigate(['/search', query, 'all']);
  }

  private listenToSearchParam() {
    this.activatedRoute.params.subscribe((params) => {
      if (params?.keyword) {
        this.searchedQuery = params.keyword;
        this.showDefaultView = false;
        this.detailMode = this.activatedRoute.snapshot.data?.detailMode;
        if (this.detailMode) {
          this.performDetailSearch(this.searchedQuery);
        } else {
          this.performSearch(this.searchedQuery);
        }
      } else {
        this.showDefaultView = true;
      }
    });
  }

  private performSearch(query: string) {
    this.panelService
      .searchProductByName(query, this.regionService.selectedRegion.id)
      .subscribe((res) => {
        this.searchResult = res.results.map((item) => ({
          ...item,
          url: this.getUrl(item.id, item.name),
        }));
      });
  }

  private performDetailSearch(query: string, ordering?: string) {
    this.selectedSortLabel = this.sortOptions.filter(s => s.value === this.activatedRoute.snapshot.queryParams?.sort)[0]?.label;
    this.panelService
      .getProductList({
        search: query,
      })
      .subscribe((data) => {
        this.nextpage = data.next;
        this.resultCount = data.count;
        this.detailedSearchResult = this.getSearchList(data.results);
        this.paginationService.setNextPageMethod(this.getPage.bind(this));
        if (ordering) {
          this.router
            .navigate([], {
              queryParams: { sort: ordering },
              relativeTo: this.activatedRoute,
              queryParamsHandling: 'merge',
            })
            .then((status) => this.setSortOptions());
        }
      });
  }

  private getSearchList(list: Product[]) {
    return list.map((product) => new ProductCard(product, undefined));
  }

  logSearch() {}

  private getUrl(id: number, name: string) {
    let title = name.replace(/[^a-zA-Z0-9]+/g, '-');
    return `/product/${id}/${title}`;
  }

  
}
